// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import store from "./store";
import VueAMap from 'vue-amap';
// 图片预览组件
import ImagePreview from "./components/ImagePreview"
// import VueAxios from "vue-axios";
// 引用elementUI组件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 引用swiper组件
import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/swiper-bundle.css";
import "swiper/css/swiper.css";

// import directive from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
Vue.component('ImagePreview', ImagePreview);
Vue.config.productionTip = false;


setTimeout(()=>{
  localStorage.clear();
  Vue.use(VueAMap);
},0)
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(ElementUI);





// 替换路径的过滤器
Vue.filter("content", function(msg) {
  return msg.replace(/\.\.\/\.\.\//g, "http://210.12.220.81:11009/");
  // return msg.replace(/\.\.\/\.\.\//g, "http://192.168.1.139:8081/");
});

// 路由跳转后返回到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});


VueAMap.initAMapApiLoader({
  key: '1bb9c47c179fdb87ab689508c2d9d34b',
  plugin: ['AMap.InfoWindow','AMap.Autocomplete','AMap.PlaceSearch','AMap.Scale','AMap.OverView','AMap.ToolBar','AMap.MapType','AMap.PolyEditor','AMap.MouseTool','AMap.CircleEditor','AMap.GeoJSON','AMap.Geocoder','AMap.TileLayer','AMap.GeometryUtil','AMap.Autocomplete',' AMap.Marker'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.15'
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  Vuex,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js